import { Injectable, signal } from '@angular/core';
import { TimetableType } from './devices.model';

@Injectable()
export class DevicesService {
  public readonly timetableMode = signal<TimetableType>(TimetableType.Regular);

  public setTimetableMode(value: TimetableType): void {
    this.timetableMode.set(value);
  }

  public toggleTimetableMode(): void {
    const currentType = this.timetableMode();

    switch (currentType) {
      case TimetableType.Regular:
        this.timetableMode.set(TimetableType.Calendar);
        break;
      case TimetableType.Calendar:
        this.timetableMode.set(TimetableType.Regular);
        break;
      default:
        throw new Error(`Unknown timetable type ${currentType}`);
    }
  }
}
